import { createHttpClient } from '@/lib/api-client';
import { disconnectSocket } from './realtime';
import { tokenStore } from './tokenStore';

export { tokenStore };

export const api = createHttpClient({
  baseURL: import.meta.env.VITE_API_URL ?? '/api',
  tokenStore,
  locale: localStorage.getItem('venue.locale') ?? 'en',
  /**
   * The refresh failed and this browser is no longer anybody. Two things have to
   * happen, and the socket half was missing.
   *
   * A socket is authenticated **once, at connect**, and this app keeps exactly
   * one for the whole tab. Clearing the tokens and routing to `/login` is a
   * client-side navigation with no reload, so without the teardown below the
   * socket stays open, still holding the previous user's rooms on the previous
   * user's credential — and `getSocket()` hands that same object to whoever logs
   * in next, whose room joins are then authorized against the scopes of the
   * person who just left.
   */
  onUnauthorized: () => {
    tokenStore.set(null);
    disconnectSocket();
    if (!location.pathname.startsWith('/login')) location.href = '/login';
  },
});
